import SimpleBoxLoaderCommon from './containers/simpleBoxLoaderCommon'

export {default as SimpleBoxLoaderCommonLayout} from './components/simpleBoxLoaderCommonLayout'

export default SimpleBoxLoaderCommon
